/* FRAUENSTIMME™ · SAT Akademie · Interaktives Deck
 * Quelle: Originalfolien Nenad Vladović · Korrekturen integriert
 * Stand: 5 Folien · weitere folgen */
export const frauenstimmeSlides = [
  {
    num: 1,
    type: "cover",
    title: "FRAUENSTIMME™",
    subtitle: "Deine Essenz. Deine Wirkung. Dein Erbe.",
    intro:
      "FRAUENSTIMME™ ist mehr als ein Programm. Es ist ein Ruf. Ein Weg zurück zu dir selbst. Eine Bewegung von Frauen, die sich erinnern, wer sie wirklich sind — für sich, ihre Familie, ihre Werte und die Welt.",
    tagline: "HERZ · VERSTAND · SEELE · KRAFT",
    closing: "Weil die Welt Frauen braucht, die in ihrer Kraft stehen und aus ihrem Herzen leben.",
    side: {
      title: "Die Welt wartet auf dich",
      items: [
        "Du bist nicht hier, um kleiner zu werden.",
        "Du bist hier, um zu erinnern.",
        "An deine Wahrheit. An deine Würde. An deine Stimme.",
      ],
    },
  },

  {
    num: 2,
    type: "content",
    layout: "grid",
    kicker: "WARUM FRAUENSTIMME™?",
    title: "Weil die Welt Frauen braucht, die sich selbst kennen und leben.",
    subtitle:
      "Die Welt verändert sich. Alte Rollen lösen sich auf. Frauen tragen heute mehr Verantwortung denn je — für sich, für ihre Familien, für ihre Berufe, für diese Welt.",
    intro:
      "Doch echte Veränderung beginnt nicht im Außen. Sie beginnt in dir. Wenn eine Frau sich erinnert, wer sie wirklich ist, verändert sich alles — in ihrem Leben und im Leben anderer.",
    bullets: [
      { h: "Du bist mehr", t: "Als die Rollen, die du spielst." },
      { h: "Deine Stimme", t: "Gehört und gehört wird." },
      { h: "Deine Intuition", t: "Dein Wegweiser ist." },
      { h: "Dein Wachstum", t: "Andere Frauen inspirieren darf." },
      { h: "Deine Essenz", t: "Die Welt bereichert." },
    ],
    mantra:
      "Eine Frau, die in ihre Kraft tritt, heilt nicht nur sich selbst, sie heilt Generationen und verändert die Welt.",
    cta: {
      title: "Die Zeit ruft nicht nach mehr Anpassung",
      sub: "Die Zeit ruft nach dir.",
    },
  },

  {
    num: 3,
    type: "content",
    layout: "grid",
    kicker: "DIE KRAFT DER FRAU",
    title: "Sanft und unaufhaltsam.",
    subtitle:
      "Eine Frau trägt Leben in sich. Sie spürt, nährt und verbindet. Sie schafft, heilt und inspiriert. Sie hält Räume, in denen Neues entsteht. Sie ist sanft — und doch unaufhaltsam, wenn es um das geht, was wirklich zählt.",
    intro: "Wenn eine Frau in ihre Kraft tritt, verändert sich alles.",
    bullets: [
      { h: "Intuition", t: "Sie spürt, was andere übersehen." },
      { h: "Mitgefühl", t: "Sie nährt, heilt und verbindet." },
      { h: "Stärke", t: "Sie steht auf, auch wenn es schwer ist." },
      { h: "Weisheit", t: "Sie lernt, wächst und lehrt." },
      { h: "Wandel", t: "Sie lässt los, um Neues zu erschaffen." },
      { h: "Vision", t: "Sie sieht das Ganze und das Wesentliche." },
    ],
    mantra:
      "Die weibliche Kraft ist nicht laut. Aber sie ist die Kraft, die bleibt, wenn alles andere vorbei ist.",
    cta: {
      title: "Die Welt braucht Frauen",
      sub: "Die sich selbst kennen, ihre Kraft leben und damit die Welt bereichern.",
    },
  },

  {
    num: 4,
    type: "content",
    layout: "grid",
    kicker: "DIE HERAUSFORDERUNGEN MODERNER FRAUEN",
    title: "Zwischen Erwartungen und innerem Ruf.",
    subtitle:
      "Die Welt stellt Frauen heute vor nie dagewesene Herausforderungen. Zwischen alten Erwartungen und neuen Möglichkeiten. Zwischen Stärke zeigen und Weiblichkeit leben. Zwischen Karriere, Familie, Selbstverwirklichung und einem inneren Ruf nach mehr.",
    intro: "Viele Frauen funktionieren — aber sie leben nicht wirklich.",
    bullets: [
      { h: "Zu viele Rollen", t: "Sie wollen allem gerecht werden und verlieren sich selbst dabei." },
      { h: "Erschöpfung", t: "Der Spagat zwischen Geben, Funktionieren und leisem Erschöpfsein." },
      { h: "Selbstzweifel", t: "Sie zweifeln an sich, ihrem Weg und ihrem Wert." },
      { h: "Alte Prägungen", t: "Tief verankerte Muster bremsen ihre Entfaltung und Freiheit." },
      { h: "Unsichtbarkeit", t: "Ihre Bedürfnisse stehen oft hinten an — von ihr selbst." },
      { h: "Orientierungslosigkeit", t: "Sie spüren, dass da mehr ist — aber wissen nicht, wie sie dorthin gelangen." },
    ],
    mantra:
      "Sie kämpfen nicht gegen andere. Sie kämpfen oft gegen sich selbst. Es ist Zeit, das zu ändern.",
    cta: {
      title: "Diese Herausforderungen sind kein Zeichen von Schwäche",
      sub: "Sie sind ein Ruf nach Veränderung. Frauenstimme™ hilft dir, diesen Ruf zu hören und zu leben.",
    },
  },

  {
    num: 5,
    type: "content",
    layout: "grid",
    kicker: "DER SAT ANSATZ",
    title: "Ganzheitlich · Tief · Wirklich.",
    subtitle:
      "FRAUENSTIMME™ basiert auf einem ganzheitlichen Ansatz, der Herz, Verstand, Körper und Seele verbindet.",
    intro:
      "Wir arbeiten auf allen Ebenen deines Seins, um nachhaltige Veränderung zu ermöglichen. Es geht nicht darum, mehr zu leisten. Es geht darum, mehr du selbst zu sein.",
    bullets: [
      { h: "Herz", t: "Wir öffnen dein Herz für dich selbst, für Liebe, Mitgefühl und echte Verbindung — zu dir und anderen." },
      { h: "Verstand", t: "Wir klären Gedankenmuster, lösen innere Blockaden und stärken deinen bewussten Fokus." },
      { h: "Körper", t: "Wir aktivieren deine Lebensenergie, fördern Gesundheit und bringen dich in Einklang mit deinem Körper." },
      { h: "Seele", t: "Wir verbinden dich mit deiner Intuition, deiner Bestimmung und deiner inneren Weisheit." },
    ],
    mantra:
      "Ein ganzheitlicher Ansatz bedeutet, dich in deiner Gesamtheit zu sehen und zu ehren.",
    cta: {
      title: "Dieser Ansatz schafft keine oberflächlichen Veränderungen",
      sub: "Er schafft echte, tiefe Transformation. Von innen nach außen. Von dir in die Welt.",
    },
    closing: "Echt. Tief. Wirklich. Das ist Frauenstimme™.",
  },
  {
    num: 6,
    type: "content",
    layout: "grid",
    kicker: "HERZ · VERSTAND · SEELE · KRAFT",
    title: "Unsere Angebote — für dich. Für dein Leben. Für die Welt.",
    subtitle:
      "FRAUENSTIMME™ ist mehr als Inspiration. Es ist ein Raum, in dem du dich erinnerst, wer du bist — und in dem du zur Frau wirst, die du tief in dir schon immer warst.",
    intro:
      "Entdecke unsere Angebote, die dich auf deinem Weg unterstützen, stärken und begleiten.",
    bullets: [
      { h: "Coachings & 1:1 Begleitung", t: "Individuelle Begleitung, die dich erkennt, stärkt und in deine volle Kraft führt." },
      { h: "Workshops & Seminare", t: "Tiefgehende Erlebnisse, die dein Bewusstsein erweitern und nachhaltige Veränderung ermöglichen." },
      { h: "Frauenkreise & Community", t: "Verbindung · Austausch · Schwesterlichkeit. Gemeinsam wachsen, einander halten und inspirieren." },
      { h: "Online-Programme & Kurse", t: "Flexibel, tiefgehend und transformierend — für dein Wachstum, in deinem Tempo, wann und wo du willst." },
      { h: "Reisen & Retreats", t: "Heilende Auszeiten an kraftvollen Orten, um loszulassen, aufzutanken und dich neu zu entdecken." },
    ],
    mantra:
      "Du musst nicht perfekt sein, um kraftvoll zu sein. Du musst nur beginnen, dir selbst treu zu sein.",
    cta: {
      title: "Alle Angebote haben ein Ziel",
      sub: "Dich zu erinnern. Dich zu stärken. Dich zu befreien — für dich, für dein Leben, für die Welt.",
    },
  },

  {
    num: 7,
    type: "content",
    layout: "grid",
    kicker: "UNSERE METHODEN",
    title: "Tiefgehend. Praktisch. Wirksam.",
    subtitle:
      "Wir verbinden wissenschaftlich fundierte Ansätze mit spiritueller Weisheit und jahrelanger praktischer Erfahrung. Unsere Methoden gehen unter die Oberfläche — sie berühren, lösen, integrieren und transformieren.",
    intro: "Du wirst gesehen. Du wirst gehalten. Du wirst erinnert, wer du wirklich bist.",
    bullets: [
      { h: "Innere Arbeit", t: "Wir gehen tief: zu deinen Überzeugungen, Mustern und Prägungen — und lösen, was dich blockiert." },
      { h: "Herzöffnung", t: "Durch geführte Prozesse, Meditationen und Rituale öffnest du dein Herz für Liebe, Vertrauen und Selbstannahme." },
      { h: "Bewusstsein", t: "Wissen, Reflexion und Klarheit stärken dein Selbstverständnis und schaffen neue Perspektiven." },
      { h: "Integration", t: "Wir verankern Erkenntnisse im Alltag — durch Tools, Übungen und konkrete Schritte, die wirken und nachhaltig bleiben." },
      { h: "Gemeinschaft", t: "Austausch, Inspiration und echte Verbindung in einem geschützten Raum von Frauen für Frauen." },
      { h: "Transformation", t: "Von innen nach außen. Du veränderst dich — und damit dein Leben, deine Beziehungen und die Welt." },
    ],
    mantra:
      "Echte Veränderung beginnt, wenn du dich selbst auf einer tieferen Ebene begegnest. Dort beginnt deine Freiheit.",
    cta: {
      title: "Unsere Methoden sind keine Theorie",
      sub: "Sie sind erprobt. Erlebt. Erfolgreich. Weil du es wert bist. Wir geben dir Werkzeuge. Du gehst deinen Weg. Wir gehen ein Stück mit dir.",
    },
  },

  {
    num: 8,
    type: "content",
    layout: "grid",
    kicker: "FÜR WEN IST FRAUENSTIMME™?",
    title: "Für jede Frau, die mehr will.",
    subtitle:
      "FRAUENSTIMME™ ist für Frauen in jeder Lebensphase, in jeder Rolle und in jedem Wandel. Egal, wo du gerade stehst — du bist willkommen. Egal, was du schon erreicht hast — es darf noch mehr sein.",
    intro:
      "Du musst nicht wissen, wohin. Du musst nur bereit sein, dir selbst zu begegnen. Wir gehen ein Stück mit dir.",
    bullets: [
      { h: "Frauen im Wandel", t: "Die spüren, dass sich etwas verändern darf und bereit sind, neue Wege zu gehen." },
      { h: "Beruflich engagierte Frauen", t: "Die viel leisten und sich nach mehr Sinn, Erfüllung und Balance sehnen." },
      { h: "Frauen auf dem spirituellen Weg", t: "Die sich selbst tiefer erkennen, ihre Intuition stärken und in ihre wahre Kraft kommen wollen." },
      { h: "Mütter, Partnerinnen, Töchter, Schwestern", t: "Die ihre Beziehungen bewusster gestalten und gesunde, liebevolle Verbindungen leben wollen." },
      { h: "Frauen mit Vision & Mission", t: "Die etwas in der Welt bewegen wollen und ihr einzigartiges Potenzial entfalten möchten." },
      { h: "Jede Frau", t: "Die sich selbst wichtiger nimmt und bereit ist, ihr Leben in die eigenen Hände zu nehmen." },
    ],
    mantra:
      "Es spielt keine Rolle, wie alt du bist, woher du kommst oder was du schon hinter dir hast. Es ist Zeit — für dich. Für deine Stimme. Für dein Leben.",
    cta: {
      title: "Es gibt kein richtig oder falsch",
      sub: "Es gibt nur dich. Und deinen Weg. Wir sind hier, um dich zu unterstützen, zu stärken und zu begleiten. Für jede Frau. Für wahre Veränderung. Für die Welt.",
    },
  },

  {
    num: 9,
    type: "content",
    layout: "grid",
    kicker: "DEIN VERMÄCHTNIS ALS FRAU",
    title: "Was bleibt, wenn du gehst?",
    subtitle:
      "Am Ende zählt nicht, was du hattest. Sondern, was du gegeben hast. Was du in Bewegung gesetzt hast. Die Liebe, die du gelebt hast. Die Wahrheiten, die du ausgesprochen hast.",
    intro:
      "Die Frauen, die du inspiriert hast. Die Menschen, die durch dich stärker, freier und bewusster geworden sind. Dein Leben hinterlässt Spuren. Dein Vermächtnis hinterlässt Generationen.",
    bullets: [
      { h: "Lebe deine Wahrheit", t: "Sei ehrlich zu dir selbst. Deine Authentizität ist das wertvollste Geschenk." },
      { h: "Setze deine Kraft ein", t: "Nutze deine Talente, deine Stimme und deine Einzigartigkeit." },
      { h: "Hebe andere", t: "Deine Unterstützung kann der Wendepunkt im Leben einer anderen Frau sein." },
      { h: "Denke in Generationen", t: "Sei dir bewusst, dass dein heutiges Wirken die Zukunft mitgestaltet." },
      { h: "Hinterlasse Spuren", t: "Nicht perfekt. Aber echt. Nicht laut. Aber tief. Nicht für alle. Aber für die, für die es bestimmt ist." },
    ],
    mantra:
      "Du bist nicht hier, um klein zu bleiben. Du bist hier, um Großes zu bewirken. Auch wenn es im Kleinen beginnt. Das ist dein Vermächtnis.",
    cta: {
      title: "Dein Vermächtnis ist keine Frage der Größe",
      sub: "Sondern der Echtheit. Lebe es. Jetzt. Jeden Tag. Mit deinem Herzen. Du bist nicht zufällig hier — du bist hier, um etwas zu hinterlassen, das bleibt — über dich hinaus.",
    },
  },

  {
    num: 10,
    type: "content",
    layout: "grid",
    kicker: "DIE REISE BEGINNT",
    title: "Bist du bereit, dein Vermächtnis zu leben?",
    subtitle:
      "FRAUENSTIMME™ ist mehr als ein Weg. Es ist eine Rückkehr zu dir. Eine Entscheidung für dich. Eine Bewegung, die du mitgestaltest.",
    intro: "Die Welt braucht dich. Dein Licht. Deine Stimme. Deine Wahrheit. Dein Vermächtnis.",
    bullets: [],
    secondary: {
      title: "Deine nächsten Schritte",
      steps: [
        { h: "Kennenlernen", t: "Buche deinen kostenlosen Kennenlern-Call." },
        { h: "Orientieren", t: "Finde heraus, welcher Weg und welche Angebote dich jetzt am besten unterstützen." },
        { h: "Entscheiden", t: "Wähle dich. Für dich. Für dein Leben. Für dein Vermächtnis." },
        { h: "Starten", t: "Beginne deine Reise — mit Klarheit, Unterstützung und einer Gemeinschaft, die dich trägt." },
        { h: "Wirken", t: "Entfalte dein volles Potenzial, lebe deine Wahrheit und hinterlasse Spuren, die Generationen berühren." },
      ],
    },
    mantra:
      "Es geht nicht darum, mehr zu werden. Es geht darum, zu erinnern, wer du wirklich bist — und das mutig zu leben.",
    cta: {
      title: "Dein Vermächtnis wartet nicht",
      sub: "Die beste Zeit, es zu leben, ist jetzt. Wir gehen ein Stück mit dir. Dann gehst du weiter. Für dich. Für dein Leben. Für die Welt.",
    },
  },
  {
    num: 11,
    type: "content",
    layout: "grid",
    kicker: "DEIN VERMÄCHTNIS LEBT",
    title: "Heute. Morgen. Für immer.",
    subtitle:
      "Dein Vermächtnis ist mehr als das, was du hinterlässt. Es ist das, was durch dich weiterlebt. In den Menschen, die du berührst. In den Veränderungen, die du anstößt. In der Welt, die du ein Stück heller machst.",
    intro:
      "Du bist hier, um Spuren zu hinterlassen. Spuren, die bleiben. Spuren, die verbinden. Spuren, die Generationen inspirieren.",
    bullets: [
      { h: "1 · Innerer Auftrag", t: "Erkenne, wofür du wirklich hier bist. Dein Warum ist der Kompass deines Lebens." },
      { h: "2 · Bewusste Gestaltung", t: "Du gestaltest aktiv dein Leben, deine Beziehungen und deine Umgebung. Nichts geschieht zufällig." },
      { h: "3 · Herzverbindung", t: "Echte Verbindung entsteht durch Echtheit, Mitgefühl und die Bereitschaft zu dienen." },
      { h: "4 · Nachhaltige Wirkung", t: "Deine Taten, Worte und Entscheidungen haben Auswirkungen, die weit über dich hinausreichen." },
      { h: "5 · Zeitloses Erbe", t: "Dein Vermächtnis ist nicht vergänglich — es lebt weiter in allem, was du berührt und verändert hast." },
    ],
    mantra:
      "Die größte Erinnerung, die ein Mensch hinterlassen kann, ist die in anderen Menschen. Das ist wahres Erbe.",
    cta: {
      title: "Du bist nicht hier, um einfach zu existieren",
      sub: "Du bist hier, um zu erschaffen. Zu lieben. Zu wirken. Lebe dein Vermächtnis. Jeden Tag. Mit ganzem Herzen.",
    },
    closing: "Dein Leben · Deine Wirkung · Dein Vermächtnis.",
  },

  {
    num: 12,
    type: "content",
    layout: "grid",
    kicker: "DEIN VERMÄCHTNIS",
    title: "Für dich. Für andere. Für immer.",
    subtitle:
      "Was du heute lebst, bleibt nicht bei dir. Es prägt. Es berührt. Es verändert. Dein Vermächtnis ist die Liebe, die du gibst. Die Wahrheit, die du lebst. Die Kraft, die du weiterreichst.",
    intro:
      "Es ist das, was bleibt, wenn du längst gegangen bist — in den Herzen derer, die du inspiriert hast. Du bist ein Geschenk für diese Welt.",
    bullets: [
      { h: "1 · Dein inneres Licht", t: "Deine Werte, deine Liebe, deine Wahrheit. Das, was dich ausmacht — dein leuchtender Kern." },
      { h: "2 · Deine Beziehungen", t: "Die Verbindung zu anderen. Die Art, wie du liebst, unterstützt, stärkst und begleitest." },
      { h: "3 · Dein Beitrag", t: "Dein Wissen. Deine Gaben. Dein Wirken. Der Unterschied, den du in dieser Welt machst." },
      { h: "4 · Dein Wachstum", t: "Deine Entwicklung. Deine Entscheidungen. Deine Bereitschaft, immer weiter zu gehen." },
      { h: "5 · Deine Spuren", t: "Was bleibt, wenn du nicht mehr da bist. Deine Wirkung. Dein ewiges Geschenk." },
    ],
    mantra:
      "Du bist nicht hier, um einfach zu sein. Du bist hier, um ein Zeichen zu setzen. Ein Licht zu sein. Dein Vermächtnis beginnt jetzt. Und es endet nie.",
    cta: {
      title: "Dein Vermächtnis ist nicht, was du hast",
      sub: "Sondern was du hinterlässt. Lebe es. Gestalte es. Teile es. Jeden Tag. Mit ganzem Herzen. Für dich. Für andere. Für immer.",
    },
  },

  {
    num: 13,
    type: "content",
    layout: "grid",
    kicker: "DEIN VERMÄCHTNIS",
    title: "Ein Leben. Volle Wirkung.",
    subtitle:
      "Ein Vermächtnis ist kein Monument. Es ist ein Leben in Wirkung. Es ist das stille Leuchten in den Momenten, in denen niemand zuschaut. Es ist die Liebe, die bleibt. Die Kraft, die weiterträgt.",
    intro:
      "Du bist nicht hier, um perfekt zu sein. Du bist hier, um echt zu sein. Und genau darin liegt deine größte, bleibende Wirkung.",
    bullets: [
      { h: "1 · Lebe in Wahrheit", t: "Sei ehrlich zu dir selbst und handle aus deiner tiefsten Wahrheit. Das ist dein Fundament." },
      { h: "2 · Diene mit Herz", t: "Stelle deine Gaben in den Dienst anderer. Deine Liebe ist deine größte Kraft." },
      { h: "3 · Stärke andere", t: "Hebe Frauen. Ermutige. Inspiriere. Sei ein Spiegel für ihr Potenzial." },
      { h: "4 · Denke in Generationen", t: "Triff Entscheidungen, die nicht nur dir, sondern auch denen nach dir ein besseres Leben ermöglichen." },
      { h: "5 · Bleibe in Integrität", t: "Auch wenn es schwer ist. Gerade dann. Integrität macht dein Vermächtnis unvergänglich." },
    ],
    mantra:
      "Am Ende zählt nicht, wie viel du erreicht hast. Sondern wie viele Menschen durch dich erinnert wurden, wer sie wirklich sind. Das ist dein Vermächtnis. Das ist deine Wahrheit. Das bist du.",
    cta: {
      title: "Dein Vermächtnis wird nicht in Jahren gemessen",
      sub: "Sondern in Herzen, die du berührt hast. Lebe. Liebe. Wirke. Hinterlasse Spuren.",
    },
    closing: "Dein Leben · Deine Wirkung · Dein Vermächtnis.",
  },

  {
    num: 14,
    type: "content",
    layout: "grid",
    kicker: "DEIN VERMÄCHTNIS",
    title: "Dein Leben. Dein Weg. Dein Erbe.",
    subtitle:
      "Ein Vermächtnis ist das, was bleibt, wenn du längst gegangen bist. Es ist nicht das, was du besitzt. Es ist das, was du gegeben hast. Es ist die Liebe, die du gelebt hast. Es ist die Wahrheit, für die du eingestanden bist. Es ist der Mensch, der du für andere warst.",
    intro:
      "Dein Vermächtnis beginnt nicht morgen. Es beginnt jetzt. In jedem Gedanken. In jeder Entscheidung. In jeder Handlung.",
    bullets: [
      { h: "1 · Liebe", t: "Die Liebe ist die Essenz deines Vermächtnisses. Sie heilt. Sie verbindet. Sie bleibt." },
      { h: "2 · Wahrheit", t: "Deine Wahrheit ist dein Kompass. Sie gibt Orientierung. Sie schafft Vertrauen." },
      { h: "3 · Beitrag", t: "Dein Beitrag macht den Unterschied. Er verbessert Leben. Er verändert die Welt." },
      { h: "4 · Menschlichkeit", t: "Wie du Menschen behandelst, entscheidet, wie lange du in ihren Herzen lebst." },
      { h: "5 · Integrität", t: "Integrität ist dein Siegel. Sie macht dein Vermächtnis echt, glaubwürdig und unvergänglich." },
    ],
    mantra:
      "Die Zeit fragt nicht, was du gesammelt hast. Die Zeit fragt, was du hinterlassen hast. Das ist dein Erbe.",
    cta: {
      title: "Du hast alles, was es braucht",
      sub: "Um ein Vermächtnis zu hinterlassen, das Generationen inspiriert. Lebe es. Jetzt. Mit ganzem Herzen.",
    },
    closing: "Dein Weg · Dein Vermächtnis · Deine Ewigkeit.",
  },

  {
    num: 15,
    type: "content",
    layout: "grid",
    kicker: "DEIN VERMÄCHTNIS",
    title: "Lebe es. Teile es. Werde es.",
    subtitle:
      "Dein Vermächtnis ist nicht das, was du besitzt. Es ist das, was durch dich lebt. Es ist das, was du gibst, was du bewegst, was du hinterlässt — in Herzen, in Gedanken, in Generationen.",
    intro:
      "Es beginnt mit einer Entscheidung. Es wächst mit jeder Handlung. Es wird unsterblich durch deine Wahrheit. Du bist der Beginn. Du bist der Wandel. Du bist das Vermächtnis. Die Welt wartet auf dich.",
    bullets: [
      { h: "1 · Entscheide dich", t: "Wähle bewusst. Für dein Leben. Für dein Vermächtnis. Für die Wirkung, die bleibt." },
      { h: "2 · Handle jetzt", t: "Warte nicht auf den perfekten Moment. Dein Vermächtnis entsteht durch deine heutigen Taten." },
      { h: "3 · Teile deine Mission", t: "Verbinde dich. Inspiriere andere. Gemeinsam erschaffen wir eine bessere Welt." },
      { h: "4 · Hinterlasse Spuren", t: "Sei der Mensch, der du sein wolltest. Für dich. Für andere. Für Generationen, die noch kommen werden." },
    ],
    mantra:
      "Am Ende zählt nur eines: Hast du geliebt? Hast du gewirkt? Hast du Spuren hinterlassen? Wenn ja, dann hast du dein Vermächtnis gelebt. Dann warst du hier. Dann bleibst du. Für immer.",
    side: {
      title: "Deine Erinnerung für morgen",
      items: [
        "Ich entscheide mich für mein Vermächtnis.",
        "Ich lebe meine Werte.",
        "Ich handle mit Integrität.",
        "Ich liebe in Wahrheit.",
        "Ich hinterlasse Spuren.",
        "Ich bin bereit.",
        "Jetzt. Heute. Für immer.",
      ],
    },
    cta: {
      title: "Die Reise geht weiter. Mit dir.",
      sub: "Wir gehen ein Stück mit dir. Dann gehst du weiter. Nicht allein. Aber in deiner Kraft. In deinem Licht. In deinem Vermächtnis. Für dich. Für andere. Für die Welt.",
    },
    badge: {
      title: "Dein Vermächtnis ist dein Geschenk an die Welt",
      lines: ["Lebe es. Jetzt. Mit ganzem Herzen."],
    },
    closing: "Für dich · Für andere · Für die Welt.",
  },
];

export default frauenstimmeSlides;
